import type { Action } from 'redux'
import { payloadAsParam } from '../../signalr/helpers'
import type { InvokeDefinition, StreamDefinition } from '../../signalr/types'
import { getNextMessageId } from '../helpers'
import {
  type CancelPassiveOrderAction,
  type CreateOrderFromPassiveOrderAction,
  addOrUpdatePassiveOrders,
  cancelPassiveOrderFailure,
  createOrderFromPassiveOrderSuccess,
  handleCreateOrderFromPassiveOrderError
} from './actions'
import type { PassiveOrder } from './types'

export const fetchPassiveOrdersDefinition: StreamDefinition<
  [number],
  PassiveOrder[],
  Action,
  { users?: { selectedUser?: number } }
> = {
  method: 'GetPassiveOrders',
  strategy: 'switch',
  getParams: (state) => [state.users?.selectedUser ?? 0],
  mapResponse: addOrUpdatePassiveOrders,
  errorAction: 'passiveOrders.fetchPassiveOrdersError',
  cancelOn: ['passiveOrders.unsubscribePassiveOrders']
}

export const cancelPassiveOrderDefinition: InvokeDefinition<
  [string],
  void,
  CancelPassiveOrderAction
> = {
  method: 'CancelOrderFromPassiveOrders',
  getParams: payloadAsParam,
  mapError: (err, action) =>
    cancelPassiveOrderFailure(action.payload, err.message ?? err.errorCode)
}

export const resubmitOrderDefinition: InvokeDefinition<
  [number, number],
  void,
  CreateOrderFromPassiveOrderAction
> = {
  method: 'CreateOrderFromPassiveOrder',
  getParams: (_state, action) => [action.payload.orderId, getNextMessageId()],
  mapResponse: () => createOrderFromPassiveOrderSuccess(),
  mapError: (err, action) =>
    handleCreateOrderFromPassiveOrderError(
      err.message ?? '',
      action.payload.orderId
    )
}
